export const workItems = [
  {
    name: "Dividend Tracker",
    font: "'Exo', sans-serif",
    desc:
      "Stock Market app to track your dividend payouts. Hooks into two API's, one for the stock marget symbol data and one for the real-time market data. D3 for graph visualizations. Firebase for cloud database and user auth.",
    bg:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611853411/New%20Portfolio%20Site/Projects/Dividend%20Tracker/Screen_Shot_2021-01-28_at_9.53.48_AM_hb3fi4.png",
    screenshots: [
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611853411/New%20Portfolio%20Site/Projects/Dividend%20Tracker/Screen_Shot_2021-01-28_at_9.53.48_AM_hb3fi4.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611853411/New%20Portfolio%20Site/Projects/Dividend%20Tracker/Screen_Shot_2021-01-28_at_9.54.06_AM_akwbev.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611853411/New%20Portfolio%20Site/Projects/Dividend%20Tracker/Screen_Shot_2021-01-28_at_9.57.04_AM_m82ihk.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611853411/New%20Portfolio%20Site/Projects/Dividend%20Tracker/Screen_Shot_2021-01-28_at_9.58.34_AM_ioianb.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611853411/New%20Portfolio%20Site/Projects/Dividend%20Tracker/Screen_Shot_2021-01-28_at_9.58.50_AM_ibb4ff.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611853411/New%20Portfolio%20Site/Projects/Dividend%20Tracker/Screen_Shot_2021-01-28_at_9.59.21_AM_h8nchf.png",
    ],
    languages: [
      {
        name: "React",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611186564/New%20Portfolio%20Site/Projects/langIcons/react-1-logo-svgrepo-com_hzsexg.svg",
      },
      {
        name: "Redux",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611201881/New%20Portfolio%20Site/Projects/langIcons/redux-logo-svgrepo-com_y1ai7r.svg",
      },
      {
        name: "Firebase",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611207841/New%20Portfolio%20Site/Projects/langIcons/firebase-1-logo-svgrepo-com_ahry6g.svg",
      },
      {
        name: "D3",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611214567/New%20Portfolio%20Site/Projects/langIcons/d3_ooueho.svg",
      },
    ],
    github: "https://github.com/jcoops22/dividend_tracker",
    site: "https://sleepy-stonebraker-5b5314.netlify.app/",
  },
  {
    name: "Phew! Apparel",
    font: "'Shadows Into Light', cursive",
    github: "https://github.com/jcoops22/phewapparel",
    site: "https://phewapparel.herokuapp.com/",
    desc:
      "Online store built with React/Redux and Firestore cloud database. Firebase user authentication, emailed receipts and updates on shipping. Paypal and Stripe payment integration. A complete admin system to manage products and orders.",
    bg:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791947/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.37.16_PM_ttyipe.png",
    screenshots: [
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791947/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.37.16_PM_ttyipe.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791947/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.53.18_PM_ftrnap.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791947/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.52.59_PM_jzq9j5.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791940/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.50.22_PM_visx8r.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791940/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.50.57_PM_ulmgb1.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791944/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.51.24_PM_rqhx1v.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791944/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.52.45_PM_n1msia.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791938/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.52.12_PM_hqfvwp.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791942/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.53.33_PM_xnfowi.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791943/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.54.16_PM_kosd5t.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611791945/New%20Portfolio%20Site/Projects/Phew%21%20Apparel/Screen_Shot_2021-01-27_at_4.54.58_PM_abpmjw.png",
    ],
    languages: [
      {
        name: "React",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611186564/New%20Portfolio%20Site/Projects/langIcons/react-1-logo-svgrepo-com_hzsexg.svg",
      },
      {
        name: "Redux",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611201881/New%20Portfolio%20Site/Projects/langIcons/redux-logo-svgrepo-com_y1ai7r.svg",
      },
      {
        name: "Firebase",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611207841/New%20Portfolio%20Site/Projects/langIcons/firebase-1-logo-svgrepo-com_ahry6g.svg",
      },
      {
        name: "NodeJS",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611207863/New%20Portfolio%20Site/Projects/langIcons/nodejs-icon-logo-svgrepo-com_hnpz1v.svg",
      },
      {
        name: "PayPal",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611215454/New%20Portfolio%20Site/Projects/langIcons/paypal-icon-logo-svgrepo-com_prgk3y.svg",
      },
      {
        name: "Stripe",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611215551/New%20Portfolio%20Site/Projects/langIcons/stripe-svgrepo-com_lmsyfd.svg",
      },
    ],
  },
  {
    name: "Portfolio Site",
    font: "'Do Hyeon', sans-serif",
    desc:
      "My previous portfolio website. A more fun rendition of my web development portfolio. Please check it out!",
    bg:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611800553/New%20Portfolio%20Site/Projects/Old%20Portfolio%20site/Screen_Shot_2021-01-27_at_6.24.31_PM_mbci6n.png",
    screenshots: [
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611800553/New%20Portfolio%20Site/Projects/Old%20Portfolio%20site/Screen_Shot_2021-01-27_at_6.24.31_PM_mbci6n.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611800547/New%20Portfolio%20Site/Projects/Old%20Portfolio%20site/Screen_Shot_2021-01-27_at_6.24.57_PM_zxicxc.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611800552/New%20Portfolio%20Site/Projects/Old%20Portfolio%20site/Screen_Shot_2021-01-27_at_6.25.12_PM_yl8dup.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611800549/New%20Portfolio%20Site/Projects/Old%20Portfolio%20site/Screen_Shot_2021-01-27_at_6.25.50_PM_co3kvr.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611800552/New%20Portfolio%20Site/Projects/Old%20Portfolio%20site/Screen_Shot_2021-01-27_at_6.26.20_PM_jzlyzz.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611800551/New%20Portfolio%20Site/Projects/Old%20Portfolio%20site/Screen_Shot_2021-01-27_at_6.26.47_PM_cbilt3.png",
    ],
    github: "https://github.com/jcoops22/ReactSite",
    site: "https://frosty-borg-f4c129.netlify.app/",
    languages: [
      {
        name: "React",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611186564/New%20Portfolio%20Site/Projects/langIcons/react-1-logo-svgrepo-com_hzsexg.svg",
      },
    ],
  },
  {
    name: "Hair By Shandel",
    font: "'Dancing Script', cursive",
    desc:
      "Local Hair Salon business website. Static site, built with JavaScript, HTML5, CSS3, and GSAP ScrollMagic library",
    bg:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611793287/New%20Portfolio%20Site/Projects/HBS/Screen_Shot_2021-01-27_at_5.20.28_PM_f0dttv.png",
    screenshots: [
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611793287/New%20Portfolio%20Site/Projects/HBS/Screen_Shot_2021-01-27_at_5.20.28_PM_f0dttv.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611792328/New%20Portfolio%20Site/Projects/HBS/Screen_Shot_2021-01-27_at_4.59.47_PM_rrcwte.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611792330/New%20Portfolio%20Site/Projects/HBS/Screen_Shot_2021-01-27_at_5.00.03_PM_xfjz6e.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611792330/New%20Portfolio%20Site/Projects/HBS/Screen_Shot_2021-01-27_at_5.00.15_PM_pvouzw.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611792332/New%20Portfolio%20Site/Projects/HBS/Screen_Shot_2021-01-27_at_5.00.54_PM_fxw5hq.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611792330/New%20Portfolio%20Site/Projects/HBS/Screen_Shot_2021-01-27_at_5.01.02_PM_qawepz.png",
    ],
    github: "https://github.com/jcoops22/hbs",
    site: "https://jcoops22.github.io/hbs/",
    languages: [
      {
        name: "GSAP",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611214896/New%20Portfolio%20Site/Projects/langIcons/5a224f121f96bd037bf6c1c1e2b686fb_cfvh5p.png",
      },
      {
        name: "JavaScript",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611214896/New%20Portfolio%20Site/Projects/langIcons/javascript-logo-svgrepo-com_uh58dw.svg",
      },
      {
        name: "HTML5",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611214896/New%20Portfolio%20Site/Projects/langIcons/html5-svgrepo-com_oppsyd.svg",
      },
      {
        name: "CSS3",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611214896/New%20Portfolio%20Site/Projects/langIcons/css3-logo-svgrepo-com_wv5gtd.svg",
      },
    ],
  },
  {
    name: "Gym Pact",
    desc:
      "Social Media app for sharing gym workouts. Sort of an 'Instagram for workouts'. Built with React frontend Rails backend. Postgresql Database and Semantic UI for styling. Worked on a team with two other developers for this bootcamp capstone project.",
    bg:
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1606159529/Portfolio%20Site/Projects%20Images/Screen_Shot_2020-11-21_at_3.17.27_PM_niibjs.png",
    screenshots: [
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611794022/New%20Portfolio%20Site/Projects/GymPact/Screen_Shot_2021-01-27_at_5.28.13_PM_kznraa.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611794021/New%20Portfolio%20Site/Projects/GymPact/Screen_Shot_2021-01-27_at_5.28.43_PM_hvbxv6.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611794019/New%20Portfolio%20Site/Projects/GymPact/Screen_Shot_2021-01-27_at_5.28.28_PM_virr45.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611794022/New%20Portfolio%20Site/Projects/GymPact/Screen_Shot_2021-01-27_at_5.30.14_PM_nikk9d.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611794021/New%20Portfolio%20Site/Projects/GymPact/Screen_Shot_2021-01-27_at_5.28.59_PM_tg5bol.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611794020/New%20Portfolio%20Site/Projects/GymPact/Screen_Shot_2021-01-27_at_5.29.58_PM_osmnn0.png",
      "https://res.cloudinary.com/drucvvo7f/image/upload/v1611794021/New%20Portfolio%20Site/Projects/GymPact/Screen_Shot_2021-01-27_at_5.30.41_PM_i7cdh5.png",
    ],
    github: "https://github.com/devpointlabs/gym-pact",
    site: null,
    languages: [
      {
        name: "React",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611186564/New%20Portfolio%20Site/Projects/langIcons/react-1-logo-svgrepo-com_hzsexg.svg",
      },
      {
        name: "Semantic-UI",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611794883/New%20Portfolio%20Site/Projects/langIcons/logo_l49j9u.png",
      },
      {
        name: "Ruby on Rails",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611795235/New%20Portfolio%20Site/Projects/langIcons/rubyonrails-svgrepo-com_ytlfin.svg",
      },
      {
        name: "Postgresql",
        icon:
          "https://res.cloudinary.com/drucvvo7f/image/upload/v1611795347/New%20Portfolio%20Site/Projects/langIcons/postgresql-logo-svgrepo-com_moud1b.svg",
      },
    ],
  },
];
